<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M11 10h2q2-.1 2.6.4.5.6.4 2.6v6q-.1-2 .4-2.6.6-.5 2.6-.4 2-.1 2.6.4.5.6.4 2.6v3H2q-.1-2 .4-2.6Q3 19 5 19q2-.1 2.6.4.5.6.4 2.6v-9q-.1-2 .4-2.6Q9 10 11 10m.1-7q.5-1 .9-1t.9 1v.2l.3.4h.4l.2.1q1 .2 1.2.6 0 .3-.7 1.1l-.1.2-.3.3v.7q.2 1.2 0 1.3t-1.3-.3h-.2l-.4-.2-.4.1-.2.1q-1 .5-1.2.3-.3-.1-.2-1.3v-.7l-.2-.3-.1-.2q-.8-.8-.7-1.1t1.2-.6h.2l.4-.1.2-.4z"
    />
  </svg>
</template>
